import { useEffect, useState } from 'react'

import { useFetchAndLoad } from 'hooks'
import { CompanyData } from 'models/company.model'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { validateCompany } from 'services/company.service'

export default function useRegister() {
  const [searchParams] = useSearchParams()
  const { loading, callEndpoint } = useFetchAndLoad()
  const [validationComplete, setValidationComplete] = useState(false)
  const [hasError, setHasError] = useState(false)
  const [companyData, setCompanyData] = useState<CompanyData | null>(null)
  const { t } = useTranslation('register')

  // Extraer query params
  const referralCode = searchParams.get('code')
  const validationCode = searchParams.get('validation_code')

  useEffect(() => {
    const validateCompanyData = async () => {
      // Validar que ambos params existan
      if (!validationCode || !referralCode) {
        setHasError(true)
        setValidationComplete(true)
        toast.error(t('error.missing_params'), {
          theme: 'colored',
        })
        return
      }

      try {
        const response = await callEndpoint(validateCompany(validationCode))
        console.log('Respuesta del endpoint:', response.data)
        setCompanyData(response.data)
        setValidationComplete(true)
        setHasError(false)
      } catch (error) {
        console.error('Error al validar la empresa:', error)
        setHasError(true)
        setValidationComplete(true)
        toast.error(t('error.validation_failed'), {
          theme: 'colored',
        })
      }
    }

    validateCompanyData()
  }, [])

  return {
    loading,
    validationComplete,
    hasError,
    companyData,
    referralCode: referralCode || '',
    validationCode: validationCode || '',
  }
}
